<template>
    <div class="col-xs-12 m-t-20 m-b-30">
        <button id="phone_button" @click="changePage" class="btn btn-lg w-lg btn-success waves-effect waves-light ladda-button">
            <span class="ladda-label">Exibir mais</span>
        </button>
    </div>
</template>

<script>
    let urlParams = require('../mixins/url-params.js');

    export default {
        mixins: [urlParams],
        props: {
            pagination: {
                type: Object,
                required: true
            }
        },
        methods: {
            changePage: function () {
                this.$emit('changePage');
            }
        },
        mounted: function () {
            $(window).bind('pageshow', function (event) {
                if (event.originalEvent.persisted) {
                    window.location.reload();
                }
            });
        }
    }
</script>
